import { render, staticRenderFns } from "./PrivacyAndSecurityPreview.vue?vue&type=template&id=06754118"
import script from "./PrivacyAndSecurityPreview.vue?vue&type=script&lang=js"
export * from "./PrivacyAndSecurityPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports